/**
 * Deactivate Company
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';
import { track } from '../../analytics/analytics';

import {
  ACTION_DEACTIVATE_COMPANY,
  ACTION_PUT_COMPANY_STATUS_FAILURE,
  ACTION_PUT_COMPANY_STATUS_SUCCESS,
  ACTION_UPDATE_COMPANY_STATUS,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';

export function deactivateCompany(companyId: string) {
  return (dispatch: Dispatch) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: `organization/${companyId}/deactivate`,
        method: 'put',
        data: JSON.stringify({}),
        success: (response: any) => {
          enqueueSnackbarHandler(
            dispatch,
            { deactivateCompanySuccess: true },
            'success',
          );
          dispatch(updateCompanyStatus(response));
          dispatch(requestSuccess(response));
          handleTrack(response);
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_PUT_COMPANY_STATUS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_PUT_COMPANY_STATUS_FAILURE,
    payload: responseJSON,
  };
}

export function requestStarted() {
  return {
    type: ACTION_DEACTIVATE_COMPANY,
    payload: null,
  };
}

export function updateCompanyStatus(responseJSON: object) {
  return {
    type: ACTION_UPDATE_COMPANY_STATUS,
    payload: responseJSON,
  };
}

function handleTrack(data: any) {
  if (data?.payload?.id !== undefined) {
    let properties = {
      Company: data.payload.id,
      Status: data.payload.status ?? 'disabled',
    };

    track('BB_CompanyUpdated', properties);
  }
}
